import React, { useContext } from 'react';
import { View } from 'react-native';
import { GroupChannelContexts } from '@sendbird/uikit-react-native';
import { Text } from '@shared/components/text';
import { useI18n } from '@shared/i18n/useI18n';
import { useChannelTitle } from '../../hooks/useChannelTitle';
import { getPersonName } from '../../utils/channelName';

export const ChatEmptyConversation = () => {
    const { t } = useI18n();
    const { channel } = useContext(GroupChannelContexts.Fragment);
    const name = getPersonName(useChannelTitle(channel));

    return (
        <View className="flex-1 items-center justify-center px-lg">
            <Text className="text-center text-md font-bold text-gray-500">
                {name
                    ? t('screens.chat.emptyConversation', { name })
                    : t('screens.chat.emptyConversationGeneric')}
            </Text>
        </View>
    );
};
